import { createRoot } from "react-dom/client"
import "bootstrap/dist/css/bootstrap.css"
import { Provider } from "react-redux"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { ToastContainer } from "react-toastify"
import { BrowserRouter } from "react-router-dom"
import { AuthenticationProvider } from "./components/authentication/AuthenticationContext"
import "./style/style.scss"
import store from "./state/store"
import { apiClient } from "./state/api/useApi"

const container = document.getElementById("root")
const root = createRoot(container!)

apiClient.applyOverriddenDateInterceptor(
	() => store.getState().environment.overriddenDate
)

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<ToastContainer />
			<AuthenticationProvider>
				<App />
			</AuthenticationProvider>
		</BrowserRouter>
	</Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
